import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {AuthService} from "@auth0/auth0-angular";
import {catchError, Observable, switchMap, throwError} from "rxjs";

@Injectable()
export class Retry401OnceInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService
  ) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tried = req.headers.has('X-Retried-Once');

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && !tried) {
          return this.auth.getAccessTokenSilently().pipe(
            switchMap((token: string) => {
              const retried = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`,
                  'X-Retried-Once': '1'
                }
              });
              return next.handle(retried);
            })
          );
        }
        return throwError(() => err);
      })
    );
  }

}
